module.exports = __webpack_public_path__ + "static/media/file-close.cdeb4b34.svg";